module.exports = __webpack_public_path__ + "static/img/dummy-avatar.1177c379.svg";